import { useState } from 'react'
import { navigate } from 'gatsby'

const useForm = (initialValues) => {
  const [form, setForm] = useState({ ...initialValues })

  const handleSubmit = (event) => {
    if (event) event.preventDefault()

    return console.warn(form)
  }

  const handleChangeByField = (value, name) => {
    const newForm = {
      ...form,
      [name]: {
        ...form[name],
        value,
      },
    }

    if (form[name] && form[name].hasError !== undefined) {
      newForm[name].hasError =
        form[name].validation !== undefined && !form[name].validation(value)
    }

    setForm(() => newForm)
  }

  const handleUpdate = (obj) => {
    setForm(() => obj)
  }

  const handleChange = (event, name = event.target.name) => {
    event.persist()
    handleChangeByField(event.target.value, name)
  }

  const handleNumericChange = (event, name = event.target.name) => {
    const regex = /^[0-9\b]+$/
    if (event.target.value === '' || regex.test(event.target.value)) {
      handleChange(event, name)
    }
  }

  const handlePageChange = (event) => {
    handleChange(event)

    const currentSelectedOption = form[event.target.name].options.filter(
      (option) => option.value === event.target.value
    )[0]

    if (currentSelectedOption.value) {
      navigate(currentSelectedOption.value)
    }
  }

  const handleCheckbox = (event, name = event.target.name) => {
    event.persist()
    handleChangeByField(event.target.checked, name)
  }

  const handleDecrement = (event, name, quantity) => {
    event.persist()

    const newObj = Object.assign({}, form.participants.options)
    const arrayKeys = Object.keys(newObj)

    arrayKeys.forEach((key) => {
      if (newObj[key].name === name) {
        if (quantity > 0) {
          newObj[key].value = quantity - 1
          form.participants.hasError = false
        }
      }
    })

    setForm(() => ({
      ...form,
    }))
  }

  const handleIncrement = (event, name, quantity) => {
    event.persist()

    const newObj = Object.assign({}, form.participants.options)
    const arrayKeys = Object.keys(newObj)

    arrayKeys.forEach((key) => {
      if (newObj[key].name === name) {
        if (quantity < 10) {
          newObj[key].value = quantity + 1
          form.participants.hasError = false
        }
      }
    })

    setForm(() => ({
      ...form,
    }))
  }

  const validateForm = () => {
    const newForm = {}
    let formHasError = false
    Object.keys(form).forEach((key) => {
      const fieldHasValidation = form[key].validation !== undefined

      const field = {
        ...form[key],
        hasError: fieldHasValidation && !form[key].validation(form[key].value),
      }

      if (field.hasError) {
        formHasError = true
      }

      newForm[key] = field
    })

    setForm(() => newForm)

    return !formHasError
  }

  return {
    handleChange,
    handleNumericChange,
    handlePageChange,
    handleUpdate,
    handleCheckbox,
    handleChangeByField,
    handleSubmit,
    handleDecrement,
    handleIncrement,
    validateForm,
    form,
  }
}

export default useForm
